(function () {
  var d = document, root = d.documentElement;
  var header = d.querySelector('[data-site-header]');

  function setHeaderHeight() {
    if (header) root.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  function onScroll() {
    if (!header) return;
    var solid = !header.hasAttribute('data-transparent') || window.scrollY > 24;
    header.classList.toggle('is-solid', solid);
  }
  setHeaderHeight();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setHeaderHeight);
  if (header && window.ResizeObserver) new ResizeObserver(setHeaderHeight).observe(header);

  // Mobile navigation
  var toggle = d.querySelector('[data-nav-toggle]'), nav = d.querySelector('[data-nav]');
  if (toggle && nav && header) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      header.classList.toggle('nav-open', open);
    });
  }

  // Reveal sections on scroll
  var sections = d.querySelectorAll('.section');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    sections.forEach(function (s) { io.observe(s); });
  } else {
    sections.forEach(function (s) { s.classList.add('in'); });
  }
  d.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.section').forEach(function (s) { s.classList.add('in'); });
  });

  // Product gallery
  d.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.pp-main img');
    var thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = b.getAttribute('data-full');
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });
  });
})();
